import styled from "styled-components";

export const Container = styled.section`
  margin-top: 15rem;

  h2 {
    text-align: center;
    font-size: 4rem;
    margin-bottom: 3rem;
  }

  .projects {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: auto;
    gap: 2rem;
    padding: 1rem;
    overflow: hidden;
  }

  .project {
    padding: 2rem 2.5rem;
    background-color: #2b2b2b; /* Keeping the original dark background */
    border-radius: 1.5rem;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease-in-out;
    color: #fff; /* White text for readability */
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
    }

    header {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-bottom: 2rem;
      position: relative;
    }

    .logo {
      width: 120px;
      height: auto;
      margin-bottom: 1rem;
      border-radius: 50%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .header-text {
      color: #fff; /* White text for the university and major */
    }

    .university-name {
      font-size: 2rem;
      font-weight: 600;
      margin-bottom: 0.5rem;
    }

    .major {
      font-size: 1.4rem;
      font-weight: 400;
      color: #b0b0b0; /* Light gray for the major */
      margin-bottom: 1.5rem;
    }

    /* GPA Section */
    .gpa {
      position: absolute;
      top: -18px;
      right: -10px;
      background-color: #ffbc00;
      color: #fff;
      font-weight: bold;
      padding: 8px 12px;
      border-radius: 8px;
      font-size: 1.2rem;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    footer {
      margin-top: auto;
      text-align: center;
      font-size: 1.2rem;
      color: #b0b0b0; /* Light gray color for the footer */
      opacity: 0.8;
      position: relative;
    }

    footer p {
      margin: 0;
      font-size: 1.2rem;
      color: #b0b0b0;
    }
  }

  @media (max-width: 960px) {
    .projects {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 740px) {
    .projects {
      grid-template-columns: 1fr;
    }

    .project {
      padding: 1.5rem 1.8rem;
    }

    .gpa {
      position: relative;
      top: initial;
      right: initial;
      margin-top: 1rem; /* Moves the GPA label below the image and text */
      margin-left: auto;
      margin-right: auto;
      background-color: #ffbc00;
      color: #fff;
      font-weight: bold;
      padding: 8px 12px;
      border-radius: 8px;
      font-size: 1.2rem;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    footer {
      font-size: 0.9rem; /* Slightly smaller footer text on mobile */
    }

    h2 {
      font-size: 2.5rem;
    }
  }
`;
